import { atomWithStorage } from 'jotai/utils';

export const atomShowAutomationV1 = atomWithStorage(
  'profile/showAutomationV1',
  localStorage.getItem('profile/showAutomationV1')
);
